import { useState } from "react"
import { Button } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"
import { apiRoute } from "@utils/wm-functions"
import { useSession } from "next-auth/react"
import { useRouter } from "next/router"

type KeetaIntegrationModalProps = {
  isOpen: boolean
  onClose: () => void
}

export function KeetaIntegrationAlertModal({ isOpen, onClose }: KeetaIntegrationModalProps) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const router = useRouter()
  const { data: session } = useSession()

  // verifica se o modal já foi mostrado antes
  const isAlreadyShown = localStorage.getItem("keeta_integration_alert_shown") === "true"
  if (isAlreadyShown) return null

  /**
   * Integração com o Keeta
   * 
   * @remarks
   *     Atualiza o campo no banco para "mottu" e redireciona para a página de integração
   *     do Keeta.
   * 
   * @throws {Error} - Erro na integração com o Keeta
   */
  async function handleIntegrate() {
    try {
      setLoading(true)
      setError(null)

      // ♥ Atualiza o campo no banco para "mottu"
      await apiRoute("/dashboard/user/updateControls", session, 'PATCH', { beta: "mottu" })
      // grava no localStorage pra não aparecer mais
      localStorage.setItem("keeta_integration_alert_shown", "true")

      // fecha o modal
      onClose()

      // ♥ redireciona para a página de integração
      router.push("/dashboard/integrations/keeta")

    } catch (err: any) {
      console.error("Erro na integração Keeta:", err.response || err)
      setError("Falha ao integrar com o Keeta. Tente novamente mais tarde.")
    }
    finally {
      setLoading(false)
    }
  }


  /**
   * Fecha o modal de integração com o Keeta
   *
   * @remarks
   *     Grava no localStorage para não aparecer mais o modal de integração
   *     e fecha o modal
   */
  function handleDismiss() {
    localStorage.setItem("keeta_integration_alert_shown", "true")
    onClose()
  }

  if (!isOpen) return null

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton={!loading}>
        <Modal.Title className="fw-bold">Integração Keeta</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <img
            src={"/images/keeta/keeta-ola-sp.jpg"}
            alt="Keeta - Olá São Paulo"
            className="w-100 rounded"
          />
        </div>

        <h5 className="mb-3 fw-bold">Sim! Keeta chegou a São Paulo!</h5>

        <p className="text-muted">
          Um mês após o lançamento bem-sucedido de nossas operações piloto em Santos e São Vicente, a Keeta chega à maior cidade do Brasil. No centro desse crescimento está a nossa promessa de proporcionar uma experiência confiável para os consumidores, aprimorar as operações e a tecnologia para os restaurantes e criar mais oportunidades de ganhos e maior segurança para os entregadores parceiros.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleDismiss} disabled={loading}>
          Não, obrigado
        </Button>
        <Button
          variant="primary"
          onClick={handleIntegrate}
          disabled={loading}
          style={{
            backgroundColor: '#FFD700',
            borderColor: '#FFD700',
            color: '#000000',
            fontWeight: 'bold',

          }}
        >
          {loading ? "Integrando..." : "Integrar"}
        </Button>

      </Modal.Footer>
    </Modal>
  )
}
